export default "__VITE_ASSET__b91dbc32__"